import { useHistory } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import 'swiper/css';

import { GROCERIES_BACKGROUND_IMAGE } from '../../app/constants/constants';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../utils/events';
import { resizeImageIfCloudinary } from '../../utils/images/cloudinaryUtils';
import styles from "./homepageGroup.module.css";
import { COMPONENTS } from "./utils/constants";
import { GroupItem } from './utils/homepageJson.types';
import { memo } from 'react';

export const GroupElement = memo(({ title, image }: { title: string, image: string }) => {
  return <div className={styles.alignment}>
    <Avatar
      alt="category-image"
      className={styles.avatar}
      src={image}
    />
    <div className={styles.text_below}>
      <Typography variant="ingredientText2mini">{title}</Typography>
    </div>
  </div>
})

const HomepageGroup = ({ title, items, uniqueKey, homePageRow, viewedHomePageRow }: { title: string, items: GroupItem[], uniqueKey: string, homePageRow: number, viewedHomePageRow: number }) => {
  const history = useHistory();
  const newBgUrl = resizeImageIfCloudinary(GROCERIES_BACKGROUND_IMAGE, 2000, -1, -1, -1, true)
  const { logRecipeEdit } = useLogRecipeEdit();

  const handleGroupItemClick = (group: GroupItem, viewedHomePageColumn: number) => {
    logRecipeEdit(EventLogsEnum.APP_GROUP_OPENED, {
      eventData: { homePageRow, viewedHomePageRow, viewedHomePageColumn, groupDetails: { ...group } }
    })
    logRecipeEdit(EventLogsEnum.APP_LISTVIEW_OPENED, {
      eventData: { homePageRow, viewedHomePageRow, viewedHomePageColumn, component: COMPONENTS.GROUP, groupDetails: { ...group } }
    })

    history.push(`${group.action}&title=${group.title}&source=group`);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.group_container} id={`group_container-${uniqueKey}`} style={{ backgroundImage: `url(${newBgUrl})` }}>
        <Typography className={styles.text} id="group_header" variant='captionparalell'>{title}</Typography>
        <div className={styles.swiper_container} id="group_swiper">
          {items.map((item: GroupItem, index: number) => (
            <div
              className={styles.slide}
              id={`group-item-${item.id}`}
              key={item.id}
              onClick={() => handleGroupItemClick(item, index)}
            >
              <GroupElement image={item.image} title={item.title} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomepageGroup;